var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCrossIconFilled = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3579_118404)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6068 37.95C41.34 38.6812 41.34 39.8813 40.6068 40.6126C39.8756 41.3438 38.6869 41.3438 37.9538 40.6126L30.0112 32.6626L22.0125 40.6686C21.2737 41.3999 20.0775 41.3999 19.3388 40.6686C18.6019 39.9186 18.6019 38.7188 19.3388 37.9875L27.3375 29.9812L19.395 22.05C18.6619 21.3188 18.6619 20.1187 19.395 19.3874C20.1244 18.6562 21.3131 18.6562 22.0462 19.3874L29.9888 27.3374L38.0475 19.2751C38.7862 18.5438 39.9806 18.5438 40.7193 19.2751C41.4562 20.0251 41.4562 21.2062 40.7193 21.9562L32.6625 30.0188L40.6068 37.95ZM30 0C13.4306 0 0 13.425 0 30C0 46.575 13.4306 60 30 60C46.5694 60 60 46.575 60 30C60 13.425 46.5694 0 30 0Z",
    fill: "#E91411"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3579_118404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCrossIconFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cross_Icon_Filled.b22b3bcd.svg";
export { ForwardRef as ReactComponent };